export const onBiometricResult = `
subscription onBiometricResult($transactionId: ID!) {
  onBiometricResult(transactionId: $transactionId) {
    responseCode
    transactionId
    data {
      detail
      message
      messageCode
    }
    dataCustomer {
      birthDate
      documentType
      firstName
      firstSurname
      gender
      identificationNumber
      issueDate
      secondName
      secondSurname
    }
    cognitoToken {
      tokenType
      accessToken
      expiresIn
    }
  }
}
`;
